// *******************************************************************************
// 1.0 - Search Result Filter
// *******************************************************************************

const searchResultsEle = document.querySelector('.search-results');

if (searchResultsEle) {
  const toggleFilterClass = (toggle) => {
    searchResultsEle.classList.toggle('is-open-filter', toggle);
    toggleBodyScrollLock(toggle);
  };

  // ------
  // Open Search Result Filter
  // ------

  attachEvent('.search-results__filter-button .btn', 'click', () => {
    toggleFilterClass(true);
  });

  // ------
  // Close Search Result Filter
  // ------

  attachEvent('.search-results__filter-close, .search-results__filter-overlay', 'click', () => {
    toggleFilterClass(false);
  });

  // ------
  // Close Search Result Filter When Escape Key Press
  // ------

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      toggleFilterClass(false);
    }
  });
}
// ------
// Search Module With Filter
// ------
if (document.querySelector('.sc-search-results')) {
  const searchListSection = document.querySelector('.search-results__list');
  const form = document.querySelector('form.search-results__form');
  const filterButtons = document.querySelectorAll('.search-results__filter-inner input');
  const getSearchResults = async () => {
    const ajaxData = new FormData();
    ajaxData.append('action', 'getSearchResults');
    ajaxData.append('id', localData.id);
    ajaxData.append('search', document.querySelector('#search-results-search').value);
    ajaxData.append('categories', getSelectedItems('input[name="filter-categories"]'));
    ajaxData.append('types', getSelectedItems('input[name="filter-type"]'));
    ajaxData.append('tags', getSelectedItems('input[name="filter-tags"]'));
    try {
      const response = await axios.post(localData.apiURL, ajaxData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      window.history.replaceState(null, null, response.data.link);
      searchListSection.innerHTML = response.data.html;
    } catch (error) {
      console.error(error);
    }
  };
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    getSearchResults();
  });
  const getSelectedItems = (selector) =>
    [...document.querySelectorAll(selector)].filter((input) => input.checked).map(({ value }) => value);
  filterButtons.forEach((filter) => {
    filter.addEventListener('click', () => {
      getSearchResults();
    });
  });
}
